export enum ModalAccountCollection {
  HISTORY_SELECT_TYPE = 'HISTORY_SELECT_TYPE',
  HISTORY_SELECT_ACCOUNT = 'HISTORY_SELECT_ACCOUNT',
  HISTORY_SELECT_STATUS = 'HISTORY_SELECT_STATUS',
  AGENCY_WALLET_NOTE = 'AGENCY_WALLET_NOTE',
  NEW_ACCOUNT_NOTE = 'NEW_ACCOUNT_NOTE',
  TXN_7D_NOTE = 'TXN_7D_NOTE',
  EWALLET_SELECT_ACCOUNT = 'EWALLET_SELECT_ACCOUNT',
  EWALLET_INFO = 'EWALLET_INFO'
}
// Account Tabs
export enum AccountTabs {
  DEPOSIT = '/account?tab=deposit',
  WITHDRAW = '/account?tab=withdraw',
  COIN12 = '/account?tab=coin12',
  REFUND = '/account?tab=refund',
  USER_BANK = '/account?tab=user-bank',
  HISTORY_TRANSACTION = '/account?tab=history-transaction',
  HISTORY_BETTING = '/account?tab=history-betting',
  TRANSFER_MONEY = '/account?tab=transfer-money',
  INFORMATION = '/account?tab=information',
  PROMOTION = '/khuyen-mai',
  ACCOUNT_TRAIL = '/account-trial',
  CHANGE_PASSWORD = '/account?tab=change-password'
}

export const TRANSACTION_STATUS = {
  FINISHED: 'FINISHED',
  CANCEL: 'CANCEL',
  DELETE: 'DELETE',
  PENDING: 'PENDING',
  CC_PENDING: 'CC_PENDING',
  PROCESSING_STATUS:
    'PROCESSING,SMART_PAY_PROCESSING,PHONE_CARD_PROCESSING,MOMO_PROCESSING,CC_PENDING,CC_PROCESSING,PENDING,APPROVED',
  PROCESSING: 'PROCESSING,PENDING,CC_PENDING,CC_PROCESSING,SMART_PAY_PROCESSING,PHONE_CARD_PROCESSING,MOMO_PROCESSING',
  CC_PROCESSING: 'CC_PROCESSING',
  SMART_PAY_PROCESSING: 'SMART_PAY_PROCESSING',
  PHONE_CARD_PROCESSING: 'PHONE_CARD_PROCESSING',
  MOMO_PROCESSING: 'MOMO_PROCESSING',
  APPROVED: 'APPROVED'
}
export const TRANSACTION_STATUS_INFO = {
  FINISHED: {
    statusText: 'Thành công',
    statusClass: 'success'
  },
  CANCEL: {
    statusText: 'Thất bại',
    statusClass: 'fail'
  },
  DELETE: {
    statusText: 'Thất bại',
    statusClass: 'fail'
  },
  PENDING: {
    statusText: 'Đang xử lý',
    statusClass: 'processing'
  },
  CC_PENDING: {
    statusText: 'Đang xử lý',
    statusClass: 'processing'
  },
  PROCESSING: {
    statusText: 'Đang xử lý',
    statusClass: 'processing'
  },
  CC_PROCESSING: {
    statusText: 'Đang xử lý',
    statusClass: 'processing'
  },
  SMART_PAY_PROCESSING: {
    statusText: 'Đang xử lý',
    statusClass: 'processing'
  },
  PHONE_CARD_PROCESSING: {
    statusText: 'Đang xử lý',
    statusClass: 'processing'
  },
  MOMO_PROCESSING: {
    statusText: 'Đang xử lý',
    statusClass: 'processing'
  },
  APPROVED: {
    statusText: 'Đang chuyển tiền',
    statusClass: 'processing'
  }
}
export const TRANSACTION_TYPE_INFO = {
  PROMOTION_CANCEL: {
    title: 'Hủy khuyến mãi',
    type: 'Hủy khuyến mãi'
  },
  PROMOTION: {
    title: 'Khuyến mãi',
    type: 'Khuyến mãi'
  },
  COMMISSION: {
    title: 'Hoàn trả',
    type: 'Hoàn trả'
  }
}
// Transactions constant
export const TRANSACTION_TYPE = {
  PAYMENT: 'PAYMENT',
  PROMOTION_CANCEL: 'PROMOTION_CANCEL',
  PROMOTION: 'PROMOTION',
  COMMISSION: 'COMMISSION',
  TRANSFER: 'TRANSFER'
}
export const HISTORY_TRANSACTION_LIST_STATUS =
  // eslint-disable-next-line max-len
  'FINISHED,PENDING,CANCEL,PROCESSING,SMART_PAY_PROCESSING,PHONE_CARD_PROCESSING,MOMO_PROCESSING,APPROVED,CC_PENDING,CC_PROCESSING'
export const TRANSACTION_ACTION = {
  DEPOSIT: 'DEPOSIT',
  WITHDRAW: 'WITHDRAW',
  PROMOTION: 'PROMOTION',
  COMMISSION: 'COMMISSION',
  FUND_TRANSFER: 'FUND_TRANSFER'
}
export const TRANSACTION_ACTION_NAME = {
  DEPOSIT: 'Nạp tiền',
  WITHDRAW: 'Rút tiền'
}
// Betting Constants
type KeyValue = Record<string, string>
export const HISTORY_BETTING_STATUS: KeyValue = {
  WIN: 'WIN,WON,half win,half won,win',
  LOSE: 'LOSE,half lose,lose',
  DRAW: 'DRAW,Draw',
  RUNNING: 'RUNNING,RUNING,PENDING,waiting,Runing,Opened',
  CANCEL: 'reject,refund,cancel'
}

export const BETTING_STATUS_INFO = {
  LOSE: {
    statusText: 'Thua',
    statusClass: 'fail'
  },
  WIN: {
    statusText: 'Thắng',
    statusClass: 'success'
  },
  WON: {
    statusText: 'Thắng',
    statusClass: 'success'
  },
  DRAW: {
    statusText: 'Hòa',
    statusClass: 'draw'
  },
  RUNNING: {
    statusText: 'Đang chờ',
    statusClass: 'pending'
  },
  RUNING: {
    statusText: 'Đang chờ',
    statusClass: 'pending'
  },
  OPENED: {
    statusText: 'Đang chờ',
    statusClass: 'pending'
  },
  WAITING: {
    statusText: 'Đang chờ',
    statusClass: 'pending'
  },
  PENDING: {
    statusText: 'Đang chờ',
    statusClass: 'pending'
  },
  BET: {
    statusText: 'Đang chờ',
    statusClass: 'pending'
  },
  OPEN: {
    statusText: 'Đang chờ',
    statusClass: 'pending'
  },
  'HALF LOSE': {
    statusText: 'Thua một nửa',
    statusClass: 'fail'
  },
  'HALF WIN': {
    statusText: 'Thắng một nửa',
    statusClass: 'success'
  },
  'HALF WON': {
    statusText: 'Thắng một nửa',
    statusClass: 'success'
  },
  REJECT: {
    statusText: 'Bị hủy',
    statusClass: 'cancel'
  },
  REFUND: {
    statusText: 'Bị hủy',
    statusClass: 'cancel'
  },
  CANCEL: {
    statusText: 'Bị hủy',
    statusClass: 'cancel'
  }
}
export const NEW_ACCOUNT_INDIRECT_BRAND = 'new_account'
export const NEW_ACCOUNT_INDIRECT_BRAND2 = 'new_account_bongk'
export const OFFSET_SCROLL_TO_TOP = -80
